import React from 'react';
import PropTypes from 'prop-types';

import { PredefinedIcon } from '../../../shared/enums';
import useTooltip from '../../hooks/useTooltip';
import useResponsive from '../../hooks/useResponsive';
import SaveIcon from '../../../assets/save-active-icon.svg';
import DownloadIcon from '../../../assets/download-icon.svg';
import ArchiveIcon from '../../../assets/archive-icon.svg';
import DeleteIcon from '../../../assets/trash-bin-icon.svg';
import EditIcon from '../../../assets/edit-icon.svg';
import SendEmailIcon from '../../../assets/send-email-icon.svg';
import UpdatePDFIcon from '../../../assets/update-pdf-icon.svg';
import CommentIcon from '../../../assets/comment-icon-single.svg';

import styles from '../../styles/views/components/IconButton.module.scss';

const IconButton = ({
  Icon,
  tooltip,
  color,
  predefinedIconName,
  isDisabled,
  extraStyles,
  onClick,
}) => {
  const { isMobile, isTablet } = useResponsive();
  useTooltip();

  const defaultIconsMap = {
    [PredefinedIcon.SAVE]: <SaveIcon />,
    [PredefinedIcon.ARCHIVE]: <ArchiveIcon />,
    [PredefinedIcon.DELETE]: <DeleteIcon />,
    [PredefinedIcon.EDIT]: <EditIcon />,
    [PredefinedIcon.DOWNLOAD]: <DownloadIcon />,
    [PredefinedIcon.UPDATE_PDF]: <UpdatePDFIcon />,
    [PredefinedIcon.SEND_TO_MY_EMAIL]: <SendEmailIcon />,
    [PredefinedIcon.ADD_COMMENT]: <CommentIcon />,
  };

  const tooltipsFordeDaultIcons = {
    [PredefinedIcon.SAVE]: t('tooltips.save', { ns: i18next.Namespace.COMMON }),
    [PredefinedIcon.ARCHIVE]: t('tooltips.archive', { ns: i18next.Namespace.COMMON }),
    [PredefinedIcon.DELETE]: t('tooltips.delete', { ns: i18next.Namespace.COMMON }),
    [PredefinedIcon.EDIT]: t('tooltips.edit', { ns: i18next.Namespace.COMMON }),
    [PredefinedIcon.DOWNLOAD]: t('tooltips.download', { ns: i18next.Namespace.COMMON }),
    [PredefinedIcon.UPDATE_PDF]: t('tooltips.updatePDF', { ns: i18next.Namespace.COMMON }),
    [PredefinedIcon.SEND_TO_MY_EMAIL]: t('tooltips.sendEmail', { ns: i18next.Namespace.COMMON }),
    [PredefinedIcon.ADD_COMMENT]: t('tooltips.addComment', { ns: i18next.Namespace.COMMON }),
  };

  const getTooltip = (iconName) => {
    if (isDisabled || isMobile || isTablet) {
      return '';
    }

    if (iconName && tooltip) {
      return tooltip;
    }

    return iconName ? tooltipsFordeDaultIcons[iconName] : tooltip;
  };

  return (
    <div
      className={isDisabled ? styles.disabled : `${styles.wrapper} ${styles[color]}`}
      style={extraStyles}
      data-tip={getTooltip(predefinedIconName)}
      onClick={isDisabled ? () => {} : onClick}
    >
      {predefinedIconName ? defaultIconsMap[predefinedIconName] : <Icon />}
    </div>
  );
};

IconButton.propTypes = {
  Icon: PropTypes.func,
  tooltip: PropTypes.string,
  isDisabled: PropTypes.bool,
  color: PropTypes.string,
  predefinedIconName: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([null])]),
  extraStyles: PropTypes.oneOfType([PropTypes.object, PropTypes.oneOf([null])]),
  onClick: PropTypes.func.isRequired,
};

IconButton.defaultProps = {
  extraStyles: null,
  isDisabled: false,
  tooltip: '',
  color: 'red',
  predefinedIconName: null,
  Icon: () => {},
};

export default IconButton;
